import {Component, OnInit} from '@angular/core';
import {UserConstant, UserStatus} from '@modules/administration/users/user.constant';
import {RoleType, RoleTypes} from '@modules/administration/administration.const';
import {SysDateFormat} from '@app/core/constant/system.constants';
import {User} from '@modules/administration/users/interfaces/user.model';
import {NotificationService} from '@shared/services/notification.service';
import {ProfileService} from '@modules/administration/profile/profile.service';
import {BaseResponse} from '@core/models/base-response.model';
import {MESSAGE_CODE} from '@shared/constants/message-code.constant';
import {VALIDATORS} from './profile.validator';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LocalStorage} from '@core/storage/storage';
import {LOCAL_STORAGE} from '@core/constant/storage.constant';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  readonly userStatus = UserConstant.USER_STATUS;
  readonly userRoleTypes = RoleTypes;
  readonly SysDateFormat = SysDateFormat;
  readonly VALIDATORS = VALIDATORS;
  isInfoSubmitted: boolean = false;
  isPassSubmitted: boolean = false;

  infoForm: FormGroup;
  passForm: FormGroup;

  user: User;
  showPassword: boolean = false;

  constructor(
    private notiService: NotificationService,
    private profileService: ProfileService,
    private fb: FormBuilder,
  ) {
    this.infoForm = this.fb.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.email]],
      phoneNumber: [null, [Validators.pattern('^0[0-9]{9,10}$')]],
    });
    this.passForm = this.fb.group({
      oldPassword: [null, [Validators.required]],
      newPassword: [null, [Validators.required,Validators.minLength(6), Validators.pattern('^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>\\/?]).{8,}$')]],
      confirmPassword: [null, [Validators.required, Validators.minLength(6)]]
    });
  }

  get infoF() {
    return this.infoForm.controls;
  }

  get passF() {
    return this.passForm.controls;
  }

  ngOnInit(): void {
    this.profileService.getProfile().subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.user = res.data;
        this.patchData();
      } else {
        this.notiService.error(BaseResponse.getMessage(res));
      }
    }, error => this.notiService.error(BaseResponse.getMessage(error)));
  }

  private patchData() {
    if (this.user) {
      this.infoForm.patchValue(this.user);
    }
  }

  updateInfo() {
    this.isInfoSubmitted = true;
    if (this.infoForm.valid) {
      this.profileService.changeProfile(this.infoForm.value).subscribe((res: BaseResponse<any, any>) => {
        if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
          LocalStorage.setItem(LOCAL_STORAGE.KEY.USER, res.data);
          this.isInfoSubmitted = false;
          this.notiService.success("Cập nhật thành công")
        } else {
          this.notiService.error(BaseResponse.getMessage(res));
        }
      }, error => this.notiService.error(BaseResponse.getMessage(error)))
    }
  }

  changePassword() {
    this.isPassSubmitted = true;
    if (this.passForm.valid) {
      this.profileService.changePass(this.passForm.value).subscribe((res: BaseResponse<any, any>) => {
        if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
          this.isInfoSubmitted = false;
          this.notiService.success("Cập nhật thành công")

        } else {
          this.notiService.error(BaseResponse.getMessage(res));
        }
      }, error => this.notiService.error(BaseResponse.getMessage(error)))
    }
  }
}
